<template>
  <AppHeading :tag="tag" class="section-heading">
    <AppIcon v-if="icon" :icon="icon" />
    <slot />
  </AppHeading>
</template>

<script>
// Components
import AppIcon from 'Ui/AppIcon'
import AppHeading from 'Ui/AppHeading'
export default {
  name: 'SectionHeading',

  components: {
    AppIcon,
    AppHeading,
  },
  props: {
    tag: {
      type: String,
      default: 'h3',
    },
    icon: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.section-heading {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 700;
  line-height: 20px;
  color: var(--c-primary);
  margin-right: 5px;
}

.section-heading .app-icon {
  font-size: 20px;
  color: var(--c-secondary);
  margin-right: 10px;
}
</style>
